import { render, staticRenderFns } from "./ContactDetailsItem.vue?vue&type=template&id=2a65981e&scoped=true&"
import script from "./ContactDetailsItem.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsItem.vue?vue&type=style&index=0&id=2a65981e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65981e",
  null
  
)

export default component.exports